import { message } from 'antd'
import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Logs out the user and deletes their session
 */

const logout = async () => {
	try {
		await axios.post('management/logout')
		message.success('Logged out successfully')
	} catch (error: any) {
		handleAxiosError(error)
	}
}

export default logout
